import api from '@/sui/api/toolsUsage'
import convert from '@/sui/data/sheets/convert'
import ice from '@/sui/tools/ice'

const state = {
  edit: null
}

const getters = {
  edit: state => {
    if (state.edit == null) {
      return null
    }
    return convert.serverToClient(state.edit)
  }
}

const actions = {
  add ({ dispatch }, data) {
    return api.add(data)
  },

  update ({ dispatch }, data) {
    return api.add(data)
  },

  edit ({ commit }, data) {
    commit('reset')

    return api.get(data).then((response) => {
      const { v, err } = response.data
      if (err == null && v != null) {
        v.t = 'toolsUsage'
        commit('setEdit', v)
      } else {
        commit('empty', data.y, data.s)
      }

      return response
    })
  },

  status ({ dispatch }, data) {
    return api.updateStatus(data)
  }
}

const mutations = {
  empty (state, y, s) {
    state.edit = { t: 'toolsUsage', f: {}, y: y, s: s }
  },

  reset (state) {
    state.edit = null
  },

  setEdit (state, edit) {
    state.edit = ice.freeze(edit)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
